// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.annotation-link {
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  padding: 0;
  text-decoration: underline;
}

.annotation-div-heading-container {
  display: flex;
  flex-wrap: wrap;
  /* font-family: SFProText; */
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #243547;
}

.annotation-div-heading-container>* {
  margin-right: 5px;
}

.annotation-heading-container-wrapper {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/Components/AnnotationHeading/AnnotationHeading.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,0DAA0D;EAC1D,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".annotation-link {\n  width: 100%;\n  text-align: left;\n  display: flex;\n  justify-content: flex-start;\n  padding: 0;\n  text-decoration: underline;\n}\n\n.annotation-div-heading-container {\n  display: flex;\n  flex-wrap: wrap;\n  /* font-family: SFProText; */\n  font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: left;\n  color: #243547;\n}\n\n.annotation-div-heading-container>* {\n  margin-right: 5px;\n}\n\n.annotation-heading-container-wrapper {\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
